import React, { useState } from 'react';
import { Dialog } from '@headlessui/react';

const ConfirmDialog = ({
  trigger,
  title = 'Are you sure?',
  description = 'This action is irreversible.',
  confirmLabel = 'Yes',
  cancelLabel = 'Cancel',
  onConfirm,
  icon = '', // cross | button | ''
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleConfirm = () => {
    setIsOpen(false);
    onConfirm?.();
  };

  // Trigger logic (same as DeleteDialog)
  const renderTrigger = () => {
    if (icon === 'cross') {
      return (
        <span
          onClick={() => setIsOpen(true)}
          title="Logout"
          style={{
            cursor: 'pointer',
            fontSize: '14px',
            color: '#ef4444',
            marginLeft: '8px',
            display: 'inline-block',
            verticalAlign: 'middle',
            lineHeight: 1,
          }}
        >
          ❌
        </span>
      );
    } else if (icon === 'button') {
      return (
        <button
          onClick={() => setIsOpen(true)}
          style={{
            borderRadius: '5px',
            padding: '6px 14px',
            backgroundColor: '#ffe5e5',
            color: '#a94442',
            border: '1px solid #f5c6cb',
            cursor: 'pointer',
          }}
        >
          {trigger}
        </button>
      );
    } else {
      return (
        <span
          onClick={() => setIsOpen(true)}
          style={{
            cursor: 'pointer',
            color: '#ef4444',
            fontSize: '14px',
            textDecoration: 'underline',
            marginLeft: '8px',
          }}
        >
          {trigger}
        </span>
      );
    }
  };

  return (
    <>
      {renderTrigger()}
      <Dialog
        open={isOpen}
        onClose={() => setIsOpen(false)}
        className="fixed inset-0 overflow-y-auto"
        style={{ zIndex: 9999 }}
      >
        <div
          className="flex items-center justify-center min-h-screen"
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '100vh',
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            backgroundColor: 'rgba(0,0,0,0.5)',
          }}
        >
          <Dialog.Panel
            className="bg-white p-6 rounded shadow-lg"
            style={{
              backgroundColor: 'white',
              padding: '20px',
              borderRadius: '8px',
              width: '300px',
              boxShadow: '0 5px 15px rgba(0,0,0,0.3)',
            }}
          >
            <Dialog.Title style={{ fontSize: '18px', fontWeight: 'bold' }}>
              {title}
            </Dialog.Title>
            <Dialog.Description style={{ margin: '10px 0', fontSize: '14px' }}>
              {description}
            </Dialog.Description>
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                gap: '10px',
                marginTop: '20px',
              }}
            >
              <button
                onClick={() => setIsOpen(false)}
                style={{
                  padding: '6px 14px',
                  backgroundColor: '#ddd',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                }}
              >
                {cancelLabel}
              </button>
              <button
                onClick={handleConfirm}
                style={{
                  padding: '6px 14px',
                  backgroundColor: '#ef4444',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                }}
              >
                {confirmLabel}
              </button>
            </div>
          </Dialog.Panel>
        </div>
      </Dialog>
    </>
  );
};

export default ConfirmDialog;
